export class JumpWindowTracker {
  private coyoteRemaining = 0;
  private jumpBufferRemaining = 0;

  constructor(
    private readonly coyoteTime: number,
    private readonly jumpBufferTime: number,
  ) {}

  update(deltaTime: number, grounded: boolean, jumpJustPressed: boolean): boolean {
    if (grounded) {
      this.coyoteRemaining = this.coyoteTime;
    } else {
      this.coyoteRemaining = Math.max(0, this.coyoteRemaining - deltaTime);
    }

    if (jumpJustPressed) {
      this.jumpBufferRemaining = this.jumpBufferTime;
    } else {
      this.jumpBufferRemaining = Math.max(0, this.jumpBufferRemaining - deltaTime);
    }

    if (this.jumpBufferRemaining > 0 && this.coyoteRemaining > 0) {
      this.coyoteRemaining = 0;
      this.jumpBufferRemaining = 0;
      return true;
    }

    return false;
  }

  getCoyoteRemaining(): number {
    return this.coyoteRemaining;
  }

  getJumpBufferRemaining(): number {
    return this.jumpBufferRemaining;
  }
}
